(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8256],{

/***/ 5616:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Box_Box; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(63366);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(90512);
// EXTERNAL MODULE: ./node_modules/@mui/styled-engine/index.js + 1 modules
var styled_engine = __webpack_require__(32485);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/styleFunctionSx/styleFunctionSx.js
var styleFunctionSx = __webpack_require__(86523);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/styleFunctionSx/extendSxProp.js
var extendSxProp = __webpack_require__(39707);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/useTheme.js
var useTheme = __webpack_require__(96682);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/@mui/system/esm/createBox.js
'use client';



const _excluded = ["className", "component"];






function createBox(options = {}) {
  const {
    themeId,
    defaultTheme,
    defaultClassName = 'MuiBox-root',
    generateClassName
  } = options;
  const BoxRoot = (0,styled_engine["default"])('div', {
    shouldForwardProp: prop => prop !== 'theme' && prop !== 'sx' && prop !== 'as'
  })(styleFunctionSx/* default */.Z);
  const Box = /*#__PURE__*/react.forwardRef(function Box(inProps, ref) {
    const theme = (0,useTheme/* default */.Z)(defaultTheme);
    const _extendSxProp = (0,extendSxProp/* default */.Z)(inProps),
      {
        className,
        component = 'div'
      } = _extendSxProp,
      other = (0,objectWithoutPropertiesLoose/* default */.Z)(_extendSxProp, _excluded);
    return /*#__PURE__*/(0,jsx_runtime.jsx)(BoxRoot, (0,esm_extends/* default */.Z)({
      as: component,
      ref: ref,
      className: (0,clsx/* default */.Z)(className, generateClassName ? generateClassName(defaultClassName) : defaultClassName),
      theme: themeId ? theme[themeId] || theme : theme
    }, other));
  });
  return Box;
}
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/ClassNameGenerator/ClassNameGenerator.js
var ClassNameGenerator = __webpack_require__(37078);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/createTheme.js + 12 modules
var createTheme = __webpack_require__(549);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/identifier.js
var identifier = __webpack_require__(10606);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClasses/generateUtilityClasses.js
var generateUtilityClasses = __webpack_require__(1588);
;// CONCATENATED MODULE: ./node_modules/@mui/material/Box/boxClasses.js

const boxClasses = (0,generateUtilityClasses/* default */.Z)('MuiBox', ['root']);
/* harmony default export */ var Box_boxClasses = (boxClasses);
;// CONCATENATED MODULE: ./node_modules/@mui/material/Box/Box.js
'use client';







const defaultTheme = (0,createTheme/* default */.Z)();
const Box = createBox({
  themeId: identifier/* default */.Z,
  defaultTheme,
  defaultClassName: Box_boxClasses.root,
  generateClassName: ClassNameGenerator/* default.generate */.Z.generate
});
 false ? 0 : void 0;
/* harmony default export */ var Box_Box = (Box);

/***/ }),

/***/ 15861:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Typography_Typography; }
});

// UNUSED EXPORTS: TypographyRoot

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(63366);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(90512);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/styleFunctionSx/extendSxProp.js
var extendSxProp = __webpack_require__(39707);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/composeClasses/composeClasses.js
var composeClasses = __webpack_require__(94780);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/styled.js
var styled = __webpack_require__(90948);
// EXTERNAL MODULE: ./node_modules/@mui/material/DefaultPropsProvider/DefaultPropsProvider.js + 1 modules
var DefaultPropsProvider = __webpack_require__(85845);
// EXTERNAL MODULE: ./node_modules/@mui/material/utils/capitalize.js
var capitalize = __webpack_require__(98216);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClasses/generateUtilityClasses.js
var generateUtilityClasses = __webpack_require__(1588);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClass/generateUtilityClass.js
var generateUtilityClass = __webpack_require__(34867);
;// CONCATENATED MODULE: ./node_modules/@mui/material/Typography/typographyClasses.js


function getTypographyUtilityClass(slot) {
  return (0,generateUtilityClass/* default */.ZP)('MuiTypography', slot);
}
const typographyClasses = (0,generateUtilityClasses/* default */.Z)('MuiTypography', ['root', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'subtitle1', 'subtitle2', 'body1', 'body2', 'inherit', 'button', 'caption', 'overline', 'alignLeft', 'alignRight', 'alignCenter', 'alignJustify', 'noWrap', 'gutterBottom', 'paragraph']);
/* harmony default export */ var Typography_typographyClasses = ((/* unused pure expression or super */ null && (typographyClasses)));
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/@mui/material/Typography/Typography.js
'use client';



const _excluded = ["align", "className", "component", "gutterBottom", "noWrap", "paragraph", "variant", "variantMapping"];










const useUtilityClasses = ownerState => {
  const {
    align,
    gutterBottom,
    noWrap,
    paragraph,
    variant,
    classes
  } = ownerState;
  const slots = {
    root: ['root', variant, ownerState.align !== 'inherit' && `align${(0,capitalize/* default */.Z)(align)}`, gutterBottom && 'gutterBottom', noWrap && 'noWrap', paragraph && 'paragraph']
  };
  return (0,composeClasses/* default */.Z)(slots, getTypographyUtilityClass, classes);
};
const TypographyRoot = (0,styled/* default */.ZP)('span', {
  name: 'MuiTypography',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, ownerState.variant && styles[ownerState.variant], ownerState.align !== 'inherit' && styles[`align${(0,capitalize/* default */.Z)(ownerState.align)}`], ownerState.noWrap && styles.noWrap, ownerState.gutterBottom && styles.gutterBottom, ownerState.paragraph && styles.paragraph];
  }
})(({
  theme,
  ownerState
}) => (0,esm_extends/* default */.Z)({
  margin: 0
}, ownerState.variant === 'inherit' && {
  // Some elements, like <button> on Chrome have default font that doesn't inherit, reset this.
  font: 'inherit'
}, ownerState.variant !== 'inherit' && theme.typography[ownerState.variant], ownerState.align !== 'inherit' && {
  textAlign: ownerState.align
}, ownerState.noWrap && {
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap'
}, ownerState.gutterBottom && {
  marginBottom: '0.35em'
}, ownerState.paragraph && {
  marginBottom: 16
}));
const defaultVariantMapping = {
  h1: 'h1',
  h2: 'h2',
  h3: 'h3',
  h4: 'h4',
  h5: 'h5',
  h6: 'h6',
  subtitle1: 'h6',
  subtitle2: 'h6',
  body1: 'p',
  body2: 'p',
  inherit: 'p'
};

// TODO v6: deprecate these color values in v5.x and remove the transformation in v6
const colorTransformations = {
  primary: 'primary.main',
  textPrimary: 'text.primary',
  secondary: 'secondary.main',
  textSecondary: 'text.secondary',
  error: 'error.main'
};
const transformDeprecatedColors = color => {
  return colorTransformations[color] || color;
};
const Typography = /*#__PURE__*/react.forwardRef(function Typography(inProps, ref) {
  const themeProps = (0,DefaultPropsProvider/* useDefaultProps */.i)({
    props: inProps,
    name: 'MuiTypography'
  });
  const color = transformDeprecatedColors(themeProps.color);
  const props = (0,extendSxProp/* default */.Z)((0,esm_extends/* default */.Z)({}, themeProps, {
    color
  }));
  const {
      align = 'inherit',
      className,
      component,
      gutterBottom = false,
      noWrap = false,
      paragraph = false,
      variant = 'body1',
      variantMapping = defaultVariantMapping
    } = props,
    other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, _excluded);
  const ownerState = (0,esm_extends/* default */.Z)({}, props, {
    align,
    color,
    className,
    component,
    gutterBottom,
    noWrap,
    paragraph,
    variant,
    variantMapping
  });
  const Component = component || (paragraph ? 'p' : variantMapping[variant] || defaultVariantMapping[variant]) || 'span';
  const classes = useUtilityClasses(ownerState);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(TypographyRoot, (0,esm_extends/* default */.Z)({
    as: Component,
    ref: ref,
    ownerState: ownerState,
    className: (0,clsx/* default */.Z)(classes.root, className)
  }, other));
});
 false ? 0 : void 0;
/* harmony default export */ var Typography_Typography = (Typography);

/***/ }),

/***/ 53327:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(90948);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(5616);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(86886);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(15861);
/* harmony import */ var _components_head_meta__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23385);
/* harmony import */ var _components_a1_refactor_typography_WsPhantomNav__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(79001);
/* harmony import */ var _components_form_with_host_post__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(36671);
/* harmony import */ var shared_models_const_form_hotpots__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(63416);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(70917);





 // Imágenes disponibles (versión 1 - JPG):
// banner-hipotecario-1563x834.jpg  - 1563×834px  (Mobile pequeño)
// banner-hipotecario-1771x834.jpg  - 1771×834px  (Mobile grande)
// banner-hipotecario-3200x1251.jpg - 3200×1251px (Tablet)
// banner-hipotecario-3750x1251.jpg - 3750×1251px (Desktop)
// banner-hipotecario-4267x1251.jpg - 4267×1251px (Desktop grande)
// banner-hipotecario-6000x1250.jpg - 6000×1250px (XL)
//
// Imágenes disponibles (versión 2 - PNG):
// banner-hipotecario-562x300_2.png  - 562×300px   (Mobile pequeño)
// banner-hipotecario-637x300_2.png  - 637×300px   (Mobile)
// banner-hipotecario-767x300_2.png  - 767×300px   (Tablet)
// banner-hipotecario-899x300_2.png  - 899×300px   (Desktop pequeño)
// banner-hipotecario-1023x300_2.png - 1023×300px  (Desktop)
// banner-hipotecario-1441x300_2.png - 1441×300px  (XL)


var StyledBannerBox = (0,_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(function () {
  return {
    cursor: "pointer",
    width: "100%",
    height: 200,
    backgroundImage: "url('/images/v2/bpd-2025/banner-hipotecario-562x300_2.png')",
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    "@media (min-width: 300px)": {
      backgroundImage: "url('/images/v2/bpd-2025/banner-hipotecario-562x300_2.png')",
      height: 150
    },
    "@media (min-width: 350px)": {
      backgroundImage: "url('/images/v2/bpd-2025/banner-hipotecario-562x300_2.png')",
      height: 185
    },
    "@media (min-width: 400px)": {
      backgroundImage: "url('/images/v2/bpd-2025/banner-hipotecario-637x300_2.png')",
      height: 210
    },
    "@media (min-width: 500px)": {
      height: 210,
      backgroundImage: "url('/images/v2/bpd-2025/banner-hipotecario-637x300_2.png')"
    },
    "@media (min-width: 550px)": {
      height: 220,
      backgroundImage: "url('/images/v2/bpd-2025/banner-hipotecario-637x300_2.png')"
    },
    "@media (min-width: 600px)": {
      height: 250,
      backgroundImage: "url('/images/v2/bpd-2025/banner-hipotecario-767x300_2.png')"
    },
    "@media (min-width: 700px)": {
      height: 250,
      backgroundImage: "url('/images/v2/bpd-2025/banner-hipotecario-767x300_2.png')"
    },
    "@media (min-width: 800px)": {
      height: 250,
      backgroundImage: "url('/images/v2/bpd-2025/banner-hipotecario-899x300_2.png')"
    },
    "@media (min-width: 900px)": {
      height: 250,
      backgroundImage: "url('/images/v2/bpd-2025/banner-hipotecario-899x300_2.png')"
    },
    "@media (min-width: 950px)": {
      height: 250,
      backgroundImage: "url('/images/v2/bpd-2025/banner-hipotecario-1023x300_2.png')"
    },
    "@media (min-width: 1000px)": {
      height: 250,
      backgroundImage: "url('/images/v2/bpd-2025/banner-hipotecario-1023x300_2.png')"
    },
    "@media (min-width: 1020px)": {
      height: 250,
      backgroundImage: "url('/images/v2/bpd-2025/banner-hipotecario-1023x300_2.png')"
    },
    "@media (min-width: 1200px)": {
      height: 250,
      backgroundImage: "url('/images/v2/bpd-2025/banner-hipotecario-1441x300_2.png')"
    },
    "@media (min-width: 1260px)": {
      height: 250,
      backgroundImage: "url('/images/v2/bpd-2025/banner-hipotecario-1441x300_2.png')"
    },
    "@media (min-width: 1700px)": {
      height: 250,
      backgroundImage: "url('/images/v2/bpd-2025/banner-hipotecario-6000x1250.jpg')",
      backgroundSize: "contain",
      boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)"
    },
    "@media (min-width: 2000px)": {
      height: 250,
      backgroundImage: "url('/images/v2/bpd-2025/banner-hipotecario-1441x300_2.png')"
    },
    "@media (min-width: 2148px)": {
      height: 250,
      backgroundImage: "url('/images/v2/bpd-2025/banner-hipotecario-1441x300_2.png')"
    }
  };
});

var MortgageReferralBpdPage = function MortgageReferralBpdPage() {
  var metaData = {
    title: "mortgageReferralBpd",
    description: "mortgageReferralBpd",
    url: "/referimiento-hipotecario-remax-bpd",
    og_type: "page-mortgage-referral-bpd"
  };
  var refMain = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
  var refNav = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
  return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(_components_head_meta__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, metaData), (0,_emotion_react__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(_components_a1_refactor_typography_WsPhantomNav__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, null), (0,_emotion_react__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(_mui_material__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP, {
    container: true,
    bgcolor: "var(--color-brand-cream-primary)",
    justifyContent: "center",
    alignContent: "flex-start",
    alignItems: "center",
    sx: {
      minHeight: "calc(100dvh - 70px)"
    },
    display: "flex",
    ref: refMain
  }, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(_mui_material__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP, {
    container: true,
    justifyContent: "center",
    alignItems: "center",
    item: true,
    xs: 12,
    bgcolor: "var(--color-brand-blue-secondary)",
    overflow: "hidden",
    height: {
      xs: 'auto',
      md: "auto"
    },
    id: "nav",
    ref: refNav,
    columnGap: {
      xs: 1.5,
      md: 3.5
    },
    px: {
      xs: 0,
      md: 0
    },
    py: {
      xs: 2,
      md: 2
    },
    pb: {
      xs: 2,
      md: 2
    }
  }, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
    component: "img",
    src: "/images/v2/pic/imagen-09.png",
    sx: {
      display: "block",
      width: {
        xs: 96,
        sm: 120,
        md: 150
      },
      height: "auto"
    }
  }), (0,_emotion_react__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
    sx: {
      width: "5px",
      height: {
        xs: 68,
        md: 88
      },
      backgroundColor: "rgba(255,255,255,0.9)"
    }
  }), (0,_emotion_react__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
    sx: {
      maxWidth: {
        xs: 245,
        sm: 320,
        md: 520
      },
      display: "flex",
      alignItems: "center"
    }
  }, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(_mui_material__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
    sx: {
      color: "#fff",
      fontWeight: 500,
      lineHeight: 1.15,
      fontSize: {
        xs: "0.88rem",
        sm: "1.05rem",
        md: "1.45rem"
      }
    }
  }, "Encuentra a las mejores propiedades de Rep\xFAblica Dominicana y recibe asesor\xEDa personalizada."))), (0,_emotion_react__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
    sx: {
      width: "100%",
      maxWidth: 720,
      margin: "0 auto"
    }
  }, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(_components_form_with_host_post__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, shared_models_const_form_hotpots__WEBPACK_IMPORTED_MODULE_4__/* ["default"].MORTGAGE_REFERRAL_BPD */ .Z.MORTGAGE_REFERRAL_BPD)), (0,_emotion_react__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
    sx: {
      width: "100%",
      bgcolor: "#012269",
      height: "auto"
    }
  }, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(StyledBannerBox, {
    role: "img",
    "aria-label": "Banner Hipotecario RE/MAX BPD",
    onClick: function onClick() {
      window.open("https://popularenlinea.com/Personas/Paginas/prestamos/content-sections/REMAX/index.aspx", "_blank", "noopener,noreferrer");
    }
  }))));
};

var __N_SSG = true;
/* harmony default export */ __webpack_exports__["default"] = (MortgageReferralBpdPage);

/***/ }),

/***/ 79001:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _home_runner_work_websitev2_websitev2_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(71383);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(90948);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5616);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70917);


var _templateObject;





var WsPhantomNav = function WsPhantomNav() {
  return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(WsPhantomNavContainer, null);
};

/* harmony default export */ __webpack_exports__["Z"] = (WsPhantomNav);
var WsPhantomNavContainer = (0,_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_templateObject || (_templateObject = (0,_home_runner_work_websitev2_websitev2_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(["\n  width: 100%;\n  height: 70px;\n"])));

/***/ }),

/***/ 36671:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(86886);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70917);




function FormWithHostPost(props) {
  var targetId = props.targetId,
      formId = props.formId,
      onFormSubmitError = props.onFormSubmitError,
      onFormSubmitSuccess = props.onFormSubmitSuccess;
  var hasFormRenderedRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(false);
  var config = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function () {
    return {
      region: "na1",
      portalId: "24346264",
      formId: formId,
      target: "#".concat(targetId),
      onFormSubmit: function onFormSubmit(_form) {// if (onFormSubmitSuccess) {
        //   setTimeout(() => {
        //     onFormSubmitSuccess();
        //   }, 1000);
        // }
      },
      onFormError: function onFormError(_errors) {
        if (onFormSubmitError) {
          onFormSubmitError();
        }
      },
      onFormSubmitted: function onFormSubmitted(_form) {
        if (onFormSubmitSuccess) {
          onFormSubmitSuccess();
        }
      }
    };
  }, [formId, targetId, onFormSubmitError, onFormSubmitSuccess]);
  var resetTarget = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function () {
    var targetElement = document.getElementById(targetId);

    if (targetElement) {
      targetElement.innerHTML = "";
    }
  }, [targetId]);
  var createForm = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function () {
    var _window$hbspt;

    if (false) {}

    if (hasFormRenderedRef.current) {
      return;
    }

    var targetElement = document.getElementById(targetId); // Ensure the container exists before we try to clear or render the form.

    if (!targetElement) {
      return;
    }

    resetTarget(); // @ts-ignore

    var hbsptForms = (_window$hbspt = window.hbspt) === null || _window$hbspt === void 0 ? void 0 : _window$hbspt.forms;

    if (hbsptForms) {
      hbsptForms.create(config);
      hasFormRenderedRef.current = true;
    }
  }, [config, resetTarget, targetId]);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    if (false) {}

    hasFormRenderedRef.current = false;
    var scriptSrc = "https://js.hsforms.net/forms/embed/v2.js";
    var scriptId = "hs-form-script-".concat(formId);

    var handleScriptLoad = function handleScriptLoad() {
      createForm();
    };

    var markLoadedAndCreate = function markLoadedAndCreate() {
      var scriptElement = document.getElementById(scriptId);

      if (scriptElement) {
        scriptElement.setAttribute("data-loaded", "true");
      }

      handleScriptLoad();
    };

    var existingScript = document.getElementById(scriptId);

    if (existingScript) {
      if (existingScript.getAttribute("data-loaded") === "true") {
        createForm();
      } else {
        existingScript.addEventListener("load", markLoadedAndCreate);
      }
    } else {
      var script = document.createElement("script");
      script.id = scriptId;
      script.src = scriptSrc;
      script.async = true;
      script.addEventListener("load", markLoadedAndCreate);
      document.body.appendChild(script);
    }

    return function () {
      var script = document.getElementById(scriptId);

      if (script) {
        script.removeEventListener("load", markLoadedAndCreate);
      }

      resetTarget();
      hasFormRenderedRef.current = false;
    };
  }, [createForm, formId, resetTarget]);
  return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, {
    container: true,
    item: true,
    xs: 12
  }, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, {
    item: true,
    xs: 12,
    id: props.targetId
  }));
}

/* harmony default export */ __webpack_exports__["Z"] = (FormWithHostPost); // FormWithHostPost;

/***/ }),

/***/ 23385:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var next_dist_shared_lib_head__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72717);
/* harmony import */ var next_dist_shared_lib_head__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_dist_shared_lib_head__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_intl__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(42746);
/* harmony import */ var next_intl__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_intl__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _helpers_removeparams__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(57626);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70917);






function HeadMeta(props) {
  var title = props.title,
      description = props.description,
      url = props.url,
      og_type = props.og_type,
      picture = props.picture,
      canonical = props.canonical,
      keyWords = props.keyWords;
  var titleT = (0,next_intl__WEBPACK_IMPORTED_MODULE_2__.useTranslations)("title-pages");
  var MetaDescriptionT = (0,next_intl__WEBPACK_IMPORTED_MODULE_2__.useTranslations)("metaDescriptions");
  return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)((next_dist_shared_lib_head__WEBPACK_IMPORTED_MODULE_0___default()), null, title && (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("title", null, titleT(title)), description && (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("meta", {
    name: "description",
    content: description
  }), keyWords && (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("meta", {
    name: "keywords",
    content: keyWords
  }), url && (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("meta", {
    property: "og:url",
    content: "".concat("https://unete.remaxrd.com").concat(url)
  }), og_type && (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("meta", {
    property: "og:type",
    content: og_type
  }), title && (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("meta", {
    property: "og:title",
    content: title
  }), description && (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("meta", {
    property: "og:description",
    content: MetaDescriptionT(description)
  }), picture && (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("meta", {
    property: "og:image",
    content: "https://unete.remaxrd.com" + picture
  }), (url || canonical) && (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("link", {
    rel: "canonical",
    href: (0,_helpers_removeparams__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)("".concat("https://unete.remaxrd.com").concat(canonical !== null && canonical !== void 0 ? canonical : url)),
    key: "canonical"
  }));
}

/* harmony default export */ __webpack_exports__["Z"] = (HeadMeta);

/***/ }),

/***/ 63416:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var FormHotpots = {
  FRANQUICIAS: {
    formId: "9b2acf82-c910-45e4-acde-a215af7498b0",
    targetId: "FRANQUICIAS-FORM"
  },
  UNETE: {
    formId: "bf07a8e7-9992-4fad-958c-291d86b8736a",
    targetId: "JOIN-FORM"
  },
  MORTGAGE_REFERRAL_BPD: {
    formId: "4c16367a-690e-4d10-90a7-ec2dd74d43e5",
    targetId: "MORTGAGE-REFERRAL-BPD-FORM"
  },
  SUSCRIBE_BLOG_FOOTER: {
    formId: "2e0183da-89fb-4de1-bcfb-244a7167438f",
    targetId: "SUSCRIBE_BLOG_FOOTER"
  }
};
/* harmony default export */ __webpack_exports__["Z"] = (FormHotpots);

/***/ }),

/***/ 57626:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/**
 * Creates a canonical URL by removing unnecessary query parameters
 * @param url - The original URL
 * @param keepParams - Optional array of parameter names to keep
 * @returns A clean canonical URL
 */
var prepareUrl = function prepareUrl(url) {
  var keepParams = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  try {
    // Handle empty or invalid URLs
    if (!url || typeof url !== "string") return ""; // For relative URLs, prepend with origin

    var isRelative = !url.startsWith("http");
    var baseUrl =  true ? window.location.origin : 0;
    var fullUrl = isRelative ? "".concat(baseUrl).concat(url.startsWith("/") ? "" : "/").concat(url) : url; // Parse the URL

    var urlObject = new URL(fullUrl); // If no params to keep, return without query string

    if (!keepParams.length) {
      return "".concat(urlObject.origin).concat(urlObject.pathname);
    } // Create a new URLSearchParams object to manipulate parameters


    var params = new URLSearchParams(); // Only keep specified parameters

    keepParams.forEach(function (param) {
      var value = urlObject.searchParams.get(param);

      if (value) {
        params.set(param, value);
      }
    }); // Build the canonical URL

    var queryString = params.toString();
    return "".concat(urlObject.origin).concat(urlObject.pathname).concat(queryString ? "?".concat(queryString) : "");
  } catch (error) {
    // Fallback method
    try {
      var questionMarkIndex = url.indexOf("?");

      if (questionMarkIndex === -1 || !keepParams.length) {
        // No query params or nothing to keep
        return questionMarkIndex === -1 ? url : url.substring(0, questionMarkIndex);
      } // Manual parsing for fallback


      var base = url.substring(0, questionMarkIndex);
      var query = url.substring(questionMarkIndex + 1);
      var pairs = query.split("&");
      var filteredPairs = pairs.filter(function (pair) {
        var key = pair.split("=")[0];
        return keepParams.includes(key);
      });
      return filteredPairs.length > 0 ? "".concat(base, "?").concat(filteredPairs.join("&")) : base;
    } catch (_unused) {
      return url; // Return original if all else fails
    }
  }
};

var createCanonicalUrl = function createCanonicalUrl(url) {
  var keepParams = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var urlresolve = prepareUrl(url, keepParams); // console.log(urlresolve);

  return urlresolve;
};

/* harmony default export */ __webpack_exports__["Z"] = (createCanonicalUrl);

/***/ }),

/***/ 28376:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/referimiento-hipotecario-remax-bpd",
      function () {
        return __webpack_require__(53327);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 71383:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _taggedTemplateLiteral; }
/* harmony export */ });
function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2708,1629,3843,2888,179], function() { return __webpack_exec__(28376); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);